import axios from 'axios';
import Cookies from 'universal-cookie';
import { AnalyticsUser, BusinessUserDetails } from '../models';

const host = process.env.REACT_APP_ApiUrl || '';
const settingsHost = process.env.REACT_APP_SettingsApiUrl || '';
const cookie = new Cookies();

export async function getBusinessUserDetails(): Promise<BusinessUserDetails | null> {
  const url = `${host}/v1/private/me`;
  try {
    const res = await axios.get(url, { headers: getAuthHeaders() });
    return res.data;
  } catch (e) {
    console.log(`Failed to retrieve business user details. Url: ${url} Reason: ${e.message}`);
    throw e;
  }
}

export async function getAnalyticsUserId(email: string): Promise<AnalyticsUser | null> {
  try {
    const res = await axios.get(`${settingsHost}/api/settings/${email}/uniqueid`);
    return res.data;
  } catch (e) {
    console.log(`Failed to get analytics user. Reason: ${e.message}`);
    throw e;
  }
}

const getAuthHeaders = () => ({
  Authorization: `Bearer ${cookie.get('tp-b2b-access-token')}`,
  'Content-Type': 'application/json',
});
